import {
  START_COURSE,
  START_COURSE_SUCCESS,
  START_COURSE_CLEAN,
  START_COURSE_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  course: {},
}

const CourseStart = (state = initialState, action) => {
  switch (action.type) {
    case START_COURSE:
      state = {
        ...state,
        loading: true,
      }
      break
    case START_COURSE_SUCCESS:
      state = {
        ...state,
        course: action.payload.course,
        loading: false,
        done: true,
      }
      break
    case START_COURSE_CLEAN:
      state = initialState
      break
    case START_COURSE_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default CourseStart
